import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import styles from './list.module.css';
import { Dialog, Popover } from '@mui/material';
import { ChevronDown, ChevronUp, Code, Edit, Trash2, User, X, Send, CheckCircle, Clock, AlertTriangle, AlertCircle, MoreVertical } from 'react-feather';
import { useState, Fragment, useEffect, useRef } from 'react';
import { useHistory } from "react-router-dom";
import { useAuth0 } from '@auth0/auth0-react';
import { Dropdown } from 'react-bootstrap';
import MobileViewList from './MobileViewList';

const formatPhone = (phone) => {
  const cleaned = phone.replace(/\D/g, '');

  if (cleaned.length !== 10) return phone;

  return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
}

const isWithin30Days = (createdAt) => {
  if (!createdAt) return false;
  const createdDate = new Date(createdAt);
  const today = new Date();
  const diffInDays = (today - createdDate) / (1000 * 60 * 60 * 24);
  return diffInDays <= 30;
}

const VehicleList = ({ allData, filterData, setEditModalOpen, setEditData, setSelectedId, setDeleteVehicleModalOpen, setTenantModalOpen, setTenantDetails }) => {
  const redirect = useHistory();
  const { user, isAuthenticated } = useAuth0();
  const [expandedRowId, setExpandedRowId] = useState(null);
  const [expandedCardId, setExpandedCardId] = useState(null);
  const [sortItem, setSortItem] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorEl2, setAnchorEl2] = useState(null);
  const [carImage, setCarImage] = useState("");
  const [tenantImage, setTenantImage] = useState("");
  const [openPop, setOpenPop] = useState(false);

  const carPopoverActionRef = useRef(null);
  const tenantPopoverActionRef = useRef(null);

  const handleOpen = () => {
    setOpenPop(true);
  }
  const handleClose = () => {
    setOpenPop(false);
  }

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handlePopoverClose = () => {
    setAnchorEl(null);
    setCarImage("");
  };

  const handlePopoverOpen2 = (event) => {
    setAnchorEl2(event.currentTarget);
  };
  const handlePopoverClose2 = () => {
    setAnchorEl2(null);
    setTenantImage("");
  };

  const open = Boolean(anchorEl);
  const open2 = Boolean(anchorEl2);

  const toggleRow = (rowId) => {
    setExpandedRowId(prev => prev === rowId ? null : rowId);
  };

  const rowsData = allData.map((item) => {
    const isGuest = Number(item.is_guest) === 1 || item.is_guest === true || item.is_guest === 'true';

    // Load pass details from localStorage or use mock/default values
    let passType = "day";
    let passStatus = "active";
    try {
      const stored = localStorage.getItem(`vehicle_pass_${item.id}`);
      if (stored) {
        const passData = JSON.parse(stored);
        passType = passData.pass_type || "day";
        passStatus = passData.pass_status || "active";
      } else {
        const name = `${item.guest_fname || ""} ${item.guest_lname || ""}`.toLowerCase();
        if (name.includes("imani johnson")) {
          passType = "day";
          passStatus = "active";
        } else if (name.includes("diana osei")) {
          passType = "monthly";
          passStatus = "expired";
        } else if (name.includes("mark liu")) {
          passType = "day";
          passStatus = "awaiting";
        } else {
          const idNum = parseInt(item.id) || 0;
          if (idNum % 3 === 0) {
            passType = "day";
            passStatus = "active";
          } else if (idNum % 3 === 1) {
            passType = "monthly";
            passStatus = "expired";
          } else {
            passType = "day";
            passStatus = "awaiting";
          }
        }
      }
    } catch (e) {
      // Ignored
    }

    if (isGuest) {
      const fname = item.guest_fname || "";
      const lname = item.guest_lname || "";
      const initials = (fname && lname) ? `${fname[0]}${lname[0]}`.toUpperCase() : "G";
      return {
        id: item.id,
        initials,
        name: `${fname} ${lname}`.trim(),
        phone: formatPhone(item.guest_phone || ""),
        license: item.license,
        make: item.make,
        model: item.model,
        color: item.color,
        property_id: item.property_id,
        is_disabled: item.is_disabled,
        property: item.property_name,
        unit: item.apt_no,
        tenant_image: "",
        tenant_id: item.tenant_id,
        tenant_info_id: item.tenant_info_id,
        apt_id: item.apt_id,
        isNew: isWithin30Days(item.created_at),
        image_path: item.image_path,
        image_thumbail_path: item.image_thumbail_path,
        is_guest: 1,
        passType,
        passStatus,
        guest_fname: item.guest_fname || "",
        guest_lname: item.guest_lname || "",
        guest_phone: item.guest_phone || "",
        tenant_details: null
      };
    } else {
      return {
        id: item.id,
        initials: item.tenant_initial,
        name: item.tenant_name,
        license: item.license,
        make: item.make,
        model: item.model,
        color: item.color,
        property_id: item.property_id,
        property: item.property_name,
        is_disabled: item.is_disabled,
        unit: item.apt_no,
        tenant_image: item.tenant_image,
        tenant_image2: item.tenant_image2,
        tenant_id: item.tenant_id,
        tenant_info_id: item.tenant_info_id,
        apt_id: item.apt_id,
        isNew: isWithin30Days(item.created_at),
        image_path: item.image_path,
        image_thumbail_path: item.image_thumbail_path,
        is_guest: 0,
        tenant_details: { ...item.tenant_details, tenant_image: item.tenant_image, property: item.property_name, unit: item.apt_no }
      };
    }
  });

  const changeSortOrder = (type) => {
    if (type === sortItem) {
      if (sortOrder === "asc") {
        setSortOrder("desc");
      } else {
        setSortOrder("asc");
      }
    } else {
      setSortOrder("asc");
    }
    setSortItem(type);
  }

  const goToDetails = (item) => {
    if (isAuthenticated && user["https://propertydek.com/permissions"].indexOf("vehicle:update") > -1) {
      setEditModalOpen(true);
      setEditData(item);
    } else {
      return false;
    }
  }

  const goToTenantetails = (row) => {
    if (isAuthenticated && user["https://propertydek.com/permissions"].indexOf("tenant-contactinfo:read") > -1 && user["https://propertydek.com/permissions"].indexOf("tenant-journey:read") > -1) {
      redirect.push("/people/tenants/details/" + row.tenant_id);
    } else {
      setTenantModalOpen(true);
      setTenantDetails(row?.tenant_details);
    }
  }

  return (
    <div className={`${styles.IncomeListUnderSec}`}>

      <MobileViewList
        rowsData={rowsData}
        setSelectedId={setSelectedId.bind(this)}
        setDeleteVehicleModalOpen={setDeleteVehicleModalOpen.bind(this)}
        setEditData={setEditData.bind(this)}
        setEditModalOpen={setEditModalOpen.bind(this)}
        setTenantModalOpen={setTenantModalOpen.bind(this)}
        setTenantDetails={setTenantDetails.bind(this)}
      />

      <TableContainer className={`${styles.TableDiv} CustomTableDiv`}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className={`${styles.TableHead}`} style={{ width: 300 }} onClick={(e) => changeSortOrder("tenant_name")}>
                TENANT / GUEST
                {sortItem === "tenant_name" && sortOrder === "asc" && (<ChevronDown />)}
                {sortItem === "tenant_name" && sortOrder === "desc" && (<ChevronUp />)}
                {sortItem !== "tenant_name" && (<Code className={`${styles.Normal}`} />)}
              </TableCell>
              <TableCell className={`${styles.TableHead}`} style={{ width: 200 }} onClick={(e) => changeSortOrder("license")}>
                LICENSE
                {sortItem === "license" && sortOrder === "asc" && (<ChevronDown />)}
                {sortItem === "license" && sortOrder === "desc" && (<ChevronUp />)}
                {sortItem !== "license" && (<Code className={`${styles.Normal}`} />)}
              </TableCell>
              <TableCell className={`${styles.TableHead}`} style={{ width: 250 }} onClick={(e) => changeSortOrder("make")}>
                VEHICLE
                {sortItem === "make" && sortOrder === "asc" && (<ChevronDown />)}
                {sortItem === "make" && sortOrder === "desc" && <ChevronUp />}
                {sortItem !== "make" && (<Code className={`${styles.Normal}`} />)}
              </TableCell>
              <TableCell className={`${styles.TableHead}`} style={{ width: 250 }} onClick={(e) => changeSortOrder("property_name")}>
                PROPERTY / UNIT
                {sortItem === "property_name" && sortOrder === "asc" && (<ChevronDown />)}
                {sortItem === "property_name" && sortOrder === "desc" && (<ChevronUp />)}
                {sortItem !== "property_name" && (<Code className={`${styles.Normal}`} />)}
              </TableCell>
              <TableCell className={`${styles.TableHead}`} style={{ width: 200 }}>
                PARKING PASS
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rowsData.sort((a, b) => {
              if (sortItem === "tenant_name") {
                if (sortOrder === "desc") {
                  return a?.name?.localeCompare(b?.name);
                } else {
                  return b?.name?.localeCompare(a?.name);
                }
              } else if (sortItem === "license") {
                if (sortOrder === "desc") {
                  return a?.license?.localeCompare(b?.license);
                } else {
                  return b?.license?.localeCompare(a?.license);
                }
              } else if (sortItem === "make") {
                if (sortOrder === "desc") {
                  return a?.make?.localeCompare(b?.make);
                } else {
                  return b?.make?.localeCompare(a?.make);
                }
              } else if (sortItem === "model") {
                if (sortOrder === "desc") {
                  return a?.model?.localeCompare(b?.model);
                } else {
                  return b?.model?.localeCompare(a?.model);
                }
              } else if (sortItem === "color") {
                if (sortOrder === "desc") {
                  return a?.color?.localeCompare(b?.color);
                } else {
                  return b?.color?.localeCompare(a?.color);
                }
              } else if (sortItem === "property_name") {
                const propA = a?.property || "";
                const propB = b?.property || "";
                if (sortOrder === "desc") {
                  return propA.localeCompare(propB);
                } else {
                  return propB.localeCompare(propA);
                }
              } else if (sortItem === "apt_no") {
                if (sortOrder === "desc") {
                  return a?.unit?.localeCompare(b?.unit);
                } else {
                  return b?.unit?.localeCompare(a?.unit);
                }
              } else {
                return (b?.id ?? 0) - (a?.id ?? 0);
              }
            }).map((row, index) => {
              const rowClass = index % 2 === 0 ? styles.MainRowOdd : styles.MainRowEven;
              const isExpanded = expandedRowId === row.id;
              const isGuest = row.is_guest === 1;

              // Compute pass rendering properties
              let passLabel = "";
              let passSubLabel = "";
              let passColor = "";
              let passBackgroundColor = "";
              let passStatusText = "";
              let passStatusIcon = null;
              let passValidFrom = null;
              let passWasValid = null;
              let passExpires = null;
              let passRemaining = null;
              let alertClass = "";
              let alertIcon = null;
              let alertText = "";
              let passPrice = row.passType === "monthly" ? 30.00 : 5.00;
              let passName = row.passType === "monthly" ? "Monthly pass" : "Day pass";

              if (isGuest) {
                if (row.passStatus === "active") {
                  passLabel = `Active - ${row.passType === "monthly" ? "Monthly" : "Day pass"}`;
                  passSubLabel = "Expires Jun 17, 2026";
                  passColor = "#43a847";
                  passBackgroundColor = "#d4fbe5";
                  passStatusText = "Paid & Active";
                  passStatusIcon = <CheckCircle size={14} style={{ color: '#43a847' }} />;
                  passValidFrom = "Jun 16, 2026";
                  passExpires = "Jun 17, 2026";
                  passRemaining = "14h 32m";
                  alertClass = styles.AlertBannerWarning;
                  alertIcon = <AlertTriangle size={16} />;
                  alertText = "Pass expires in less than 24 hours. Send renewal link to guest.";
                } else if (row.passStatus === "expired") {
                  passLabel = `Expired - ${row.passType === "monthly" ? "Monthly" : "Day pass"}`;
                  passSubLabel = "Expired Jun 15, 2026";
                  passColor = "#e23725";
                  passBackgroundColor = "#ffe8e8";
                  passStatusText = "Expired";
                  passStatusIcon = <X size={14} style={{ color: '#E23725' }} />;
                  passWasValid = "May 16 - Jun 15, 2026";
                  alertClass = styles.AlertBannerError;
                  alertIcon = <AlertCircle size={16} />;
                  alertText = `Access restricted. ${row.passType === "monthly" ? "Monthly" : "Day"} pass expired Jun 15, 2026.`;
                } else {
                  passLabel = "Awaiting payment";
                  passSubLabel = "Link sent Jun 16";
                  passColor = "#E99A37";
                  passBackgroundColor = "#fff3e8";
                  passStatusText = "Awaiting payment";
                  passStatusIcon = <Clock size={14} style={{ color: '#E99A37' }} />;
                  alertClass = styles.AlertBannerWarning;
                  alertIcon = <AlertTriangle size={16} />;
                  alertText = "Payment link sent Jun 16. Guest has not paid yet.";
                }
              }

              return (
                <Fragment key={row.id}>
                  <TableRow
                    className={rowClass}
                    onClick={(e) => {
                      goToDetails(row);
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    <TableCell className={`${styles.TableBodyText} ${styles.ProfileImg} ${!isGuest ? styles.Hover : ''}`}>
                      {isGuest ? (
                        <div className={styles.TenantInside}>
                          <div className={styles.AvatarCircle} style={{ backgroundColor: '#E0F2FE', color: '#0284C7' }}>
                            {row.initials}
                          </div>
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                              <span className={styles.GuestNameText}>{row.name}</span>
                              <span className={styles.GuestBadge}>Guest</span>
                            </div>
                            <span className={styles.GuestPhoneText}>{row.phone}</span>
                          </div>
                        </div>
                      ) : (
                        <Fragment>
                          {row?.tenant_image !== "" ? <img src={row?.tenant_image} alt="" onMouseEnter={(e) => { setTenantImage(row?.tenant_image2); handlePopoverOpen2(e); }} onMouseLeave={handlePopoverClose2} /> : <div className={styles.AvatarCircle} style={{ backgroundColor: '#E0F2FE', color: '#0284C7' }}>
                            {row.initials}
                          </div>}
                          <div style={{ display: 'inline-flex', gap: '4px' }}>
                            <span className={styles.TenantNameText} onClick={(e) => { e.preventDefault(); e.stopPropagation(); goToTenantetails(row); }}>{row.name}</span>
                            {row.isNew && <p className={styles.NewBadgeSmall}>New</p>}
                          </div>
                        </Fragment>
                      )}
                    </TableCell>
                    <TableCell className={styles.TableBodyText}>
                      <div className={`${styles.DisplayFlex} ${styles.LicenseSec}`}>
                        <span>{row.license}</span>
                        {row?.image_thumbail_path !== "" ? <div className={`${styles.CarSec}`} onMouseEnter={(e) => { setCarImage(row?.image_path); handlePopoverOpen(e); }} onMouseLeave={handlePopoverClose}>
                          <img src={row?.image_thumbail_path} alt="" />
                        </div> :
                          <div className={`${styles.NoCarSec}`}>
                            <img src={"/static/img/no-car.png"} alt="" />
                          </div>}
                      </div>
                    </TableCell>
                    <TableCell className={styles.TableBodyText}>
                      <div className={styles.VehicleCell}>
                        <span className={styles.VehicleMakeModel}>{row.make} {row.model}</span>
                        <span className={styles.VehicleColorDot}></span>
                        <span className={styles.VehicleColor}>{row.color}</span>
                      </div>
                    </TableCell>
                    <TableCell className={`${styles.TableBodyText} ${styles.Hover}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); redirect.push("/properties/details/" + row?.property_id); }}>
                      <div className={styles.PropertyUnitCell}>
                        <span className={styles.PropertyText}>{row.property}</span>
                        <p className={styles.UnitText}>{row.unit}</p>
                      </div>
                    </TableCell>
                    {/* {isGuest ? (
                      <TableCell 
                        className={styles.TableBodyText}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          toggleRow(row.id);
                        }}
                        style={{ cursor: 'pointer', position: 'relative' }}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', paddingRight: '45px' }}>
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                            <span style={{ color: passColor, fontWeight: 600, fontSize: '10px', background: passBackgroundColor, padding: '4px 10px', borderRadius: '12px' }}>{passLabel}</span>
                            <span style={{ color: '#9CA3AF', fontSize: '10px' }}>{passSubLabel}</span>
                          </div>
                          {isExpanded ? <ChevronUp size={16} style={{ color: '#818CF8', marginLeft: '8px' }} /> : <ChevronDown size={16} style={{ color: '#818CF8', marginLeft: '8px' }} />}
                        </div>
                        {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("vehicle:update") > -1 && (
                          <Dropdown className={`${styles.ActionLeaseBUSec}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                            <Dropdown.Toggle className={`${styles.ActionsLeaseBU} ActionsBU`} id="dropdown-basic">
                              <MoreVertical />
                            </Dropdown.Toggle>
                            <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                              <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setEditModalOpen(true); setEditData(row); }}>
                                <Edit /> Edit
                              </Dropdown.Item>
                              <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => { setDeleteVehicleModalOpen(true); setSelectedId(row?.id); }}>
                                <Trash2 /> Delete
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        )}
                      </TableCell>
                    ) : (
                      <TableCell className={styles.TableBodyText} style={{ position: 'relative' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', paddingRight: '45px' }}>
                          <span className={styles.ActiveBadge}>Active</span>
                        </div>
                        {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("vehicle:update") > -1 && (
                          <Dropdown className={`${styles.ActionLeaseBUSec}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                            <Dropdown.Toggle className={`${styles.ActionsLeaseBU} ActionsBU`} id="dropdown-basic">
                              <MoreVertical />
                            </Dropdown.Toggle>
                            <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                              <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setEditModalOpen(true); setEditData(row); }}>
                                <Edit /> Edit
                              </Dropdown.Item>
                              <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => { setDeleteVehicleModalOpen(true); setSelectedId(row?.id); }}>
                                <Trash2 /> Delete
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        )}
                      </TableCell>
                    )} */}
                    <TableCell className={styles.TableBodyText} style={{ position: 'relative' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', paddingRight: '45px' }}>
                        {row.is_disabled === 1 ? <span className={styles.DisableBadge}>Disabled</span> : <span className={styles.ActiveBadge}>Active</span>}
                      </div>
                      {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("vehicle:update") > -1 && (
                        <Dropdown className={`${styles.ActionLeaseBUSec}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                          <Dropdown.Toggle className={`${styles.ActionsLeaseBU} ActionsBU`} id="dropdown-basic">
                            <MoreVertical />
                          </Dropdown.Toggle>
                          <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                            <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setEditModalOpen(true); setEditData(row); }}>
                              <Edit /> Edit
                            </Dropdown.Item>
                            <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => { setDeleteVehicleModalOpen(true); setSelectedId(row?.id); }}>
                              <Trash2 /> Delete
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      )}
                    </TableCell>
                  </TableRow>
                  {isExpanded && isGuest && (
                    <TableRow className={styles.ExpandedRow}>
                      <TableCell colSpan={5} className={styles.ExpandedCell} style={{ padding: '16px 24px' }}>
                        <div className={styles.PassDetailsContainer}>
                          <div className={styles.PassDetailsHeaderRow}>
                            <div className={styles.PassDetailsCol}>
                              <span className={styles.PassDetailLabel}>PASS TYPE</span>
                              <span className={styles.PassDetailValue}>{passName} - ${passPrice.toFixed(2)}</span>
                            </div>
                            <div className={styles.PassDetailsCol}>
                              <span className={styles.PassDetailLabel}>STATUS</span>
                              <span className={styles.PassDetailValue} style={{ display: 'flex', alignItems: 'center', gap: '4px', color: passColor }}>
                                {passStatusIcon}
                                {passStatusText}
                              </span>
                            </div>
                            {passValidFrom && (
                              <div className={styles.PassDetailsCol}>
                                <span className={styles.PassDetailLabel}>VALID FROM</span>
                                <span className={styles.PassDetailValue}>{passValidFrom}</span>
                              </div>
                            )}
                            {passWasValid && (
                              <div className={styles.PassDetailsCol}>
                                <span className={styles.PassDetailLabel}>WAS VALID</span>
                                <span className={styles.PassDetailValue}>{passWasValid}</span>
                              </div>
                            )}
                            {passExpires && (
                              <div className={styles.PassDetailsCol}>
                                <span className={styles.PassDetailLabel}>EXPIRES</span>
                                <span className={styles.PassDetailValue}>{passExpires}</span>
                              </div>
                            )}
                            {passRemaining && (
                              <div className={styles.PassDetailsCol}>
                                <span className={styles.PassDetailLabel}>REMAINING</span>
                                <span className={styles.PassDetailValue}>{passRemaining}</span>
                              </div>
                            )}
                            <div className={styles.PassActionButtons}>
                              {/* {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("vehicle:update") > -1 && (
                                <>
                                  <button className={styles.SendRenewalButton} onClick={(e) => { e.preventDefault(); e.stopPropagation(); goToDetails(row); }} style={{ background: '#6366F1', color: '#FFF' }}>
                                    <Edit size={14} style={{ marginRight: '6px' }} />
                                    Edit
                                  </button>
                                  <button className={styles.RevokeButton} onClick={(e) => { e.preventDefault(); e.stopPropagation(); setSelectedId(row.id); setDeleteVehicleModalOpen(true); }} style={{ background: '#EF4444', color: '#FFF', borderColor: '#EF4444' }}>
                                    <Trash2 size={14} style={{ marginRight: '6px' }} />
                                    Delete
                                  </button>
                                </>
                              )} */}
                              <button className={styles.SendRenewalButton} onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                                <Send />
                                Send renewal link
                              </button>
                              <button className={styles.RevokeButton} onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                                {row.passStatus === 'awaiting' ? 'Cancel pass' : 'Revoke access'}
                              </button>
                            </div>
                          </div>
                          <div className={alertClass}>
                            {alertIcon}
                            <span>{alertText}</span>
                          </div>
                        </div>
                      </TableCell>
                    </TableRow>
                  )}
                </Fragment>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      {rowsData.length === 0 && (<div className={`${styles.NoDataMain}`}>
        <div className={`${styles.NoDataIMG}`}>
          <img src="/static/img/no-car.png" alt="No Data" />
        </div>
        <p className={`${styles.NoDataText}`}>Unfortunately!</p>
        <p className={`${styles.NoDataTextSub}`}>
          we couldn't find any vehicle at this time.
        </p>
      </div>)}

      <Popover
        id="mouse-over-popover"
        sx={{ pointerEvents: "none" }}
        open={open}
        anchorEl={anchorEl}
        action={carPopoverActionRef}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <div className={`${styles.PopupImgSec}`}>
          <img
            src={carImage}
            alt=""
            onLoad={() => carPopoverActionRef.current?.updatePosition()}
          />
        </div>
      </Popover>

      <Popover
        id="mouse-over-popover2"
        sx={{ pointerEvents: "none" }}
        open={open2}
        anchorEl={anchorEl2}
        action={tenantPopoverActionRef}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        onClose={handlePopoverClose2}
        disableRestoreFocus
      >
        <div className={`${styles.PopupImgSec}`}>
          <img
            src={tenantImage}
            alt=""
            style={{ maxWidth: '400px', maxHeight: '600px' }}
            onLoad={() => tenantPopoverActionRef.current?.updatePosition()}
          />
        </div>
      </Popover>

      <Dialog
        open={openPop}
        onClose={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleClose()
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className={`${styles.PopupImgSec}`}>
          <img src={carImage} alt="" />
          <button onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleClose()
          }}><X /></button>
        </div>
      </Dialog>

    </div>
  );
}

export default VehicleList;